module.exports = __webpack_public_path__ + "static/media/newOrder.66ccc143.mp3";